import React, { Component } from 'react';
import { Tree, Input, Tooltip, Icon, Button, Table, Modal, message, Popconfirm, Select, Spin } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import SideNav from '../SideNav';
import './index.less';
import UpdateCatalog from './UpdateCatalog';
import moment from 'moment';
import ExportUtil from '../../../common/ExportUtil';
import UploadFileModal from './UploadFileModal';
import SetRemark from './SetRemark';
import PMreport from '../../user/transfer/components/PMReport';
import ViewReportModal from '../../user/transfer/components/ViewReport';
import Update from '../../execute/importantEvent/Update';

const TreeNode = Tree.TreeNode;
const Search = Input.Search;
const Option = Select.Option;


class ProjectFile extends Component {
    state = {
        treeData: [],   //目录数据
        simplifyTreeData: [],
        tableData: [],  //表格数据
        loading: false,
        pagination: {
            pageSize: 10,
            current: 1,
        },
        expandedKeys: [],
        searchValue: '',
        autoExpandParent: true,
        selectedRowKeys: [],
        selectedKeys: [],
        arry: [],
        clearArry: false,
        imageUrl: '',
        batchMarkData: [], //标记批量下载
        pathName: '', //路径名称
        titleRemark: '',
        majorEventsStatus: '', //重大事件弹窗控制
        majorEventsConfig: {}, //重大事件弹窗配置
        majorEventsData: {},

        // 部门文档迁移目录的权限缓存（key=deptFileCatalogId, value={premission, otherPremission}）
        deptFilePremissionMap: {},
    }

    componentDidMount() {
        // 1. 提取哈希中的查询参数部分（如 "data=%7B...%7D"）
        const hash = window.location.hash;
        const queryStartIndex = hash.indexOf('?');
        
        if (queryStartIndex === -1) {
            this.loadData();
            return; // 无参数时直接返回
        }
        
        // 截取 ? 后的参数字符串（如 "data=%7B%22invState%22%3A1..."）
        const queryString = hash.substring(queryStartIndex + 1);
        
        // 2. 解析参数（支持多参数，这里以 data 为例）
        const params = new URLSearchParams(queryString);
        const encodedData = params.get('data'); // 获取编码后的 data 值
        if (!encodedData) {
            console.log('未找到 data 参数');
            return;
        }
        
        try {
            // 3. 解码并解析 JSON 数据
            const decodedData = decodeURIComponent(encodedData); // 解码 URL 编码的字符串
            const data = JSON.parse(decodedData); // 解析为对象
            
            // 4. 写入新页面的 SessionStorage
            const { invState, investigationSiteName, investigationFileId } = data;
            sessionStorage.setItem('invState', invState);
            sessionStorage.setItem('investigationSiteName', investigationSiteName);
            this.loadData(investigationFileId);
            
            // 可选：清除哈希中的参数（避免刷新后重复处理）
            const cleanHash = hash.substring(0, queryStartIndex); // 保留 #/fileManagement/projectFile 部分
            window.location.hash = cleanHash; // 更新哈希，移除参数
        } catch (e) {
            console.error('解析或存储数据失败:', e);
        }
    }

    loadData = (investigationFileId) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.invFolder.queryInvCatalogTree,
            data: {
                invId: sessionStorage.invId,
            },
            dataType: 'json',
            doneResult: res => {
                const { catalogs = {} } = res;
                const data = [{ ...catalogs }];
                const simplifyTreeData = this.flattenList(data);

                let curExpandedKeys = [];
                let curCatalogId,curPathName,curCatalogType,curCreateUser,curDeptFileCatalogId = '';
                // invFileId有值说明是从发布审批那里跳转过来的
                if (investigationFileId) {
                    const invFileIdList = investigationFileId;
                    curCatalogId = Number(invFileIdList[invFileIdList.length - 1]);
                    const path = this.findNodePath(data, curCatalogId);
                    const curPathData = (path || []).filter((node) => node.id == curCatalogId)[0] || {};
                    curExpandedKeys = (path || []).map((node) => String(node.id));
                    curPathName = (path || []).map((node) => node.catalogName).join('-->');
                    curCatalogType = curPathData.catalogType;
                    curCreateUser = curPathData.createUser;
                    curDeptFileCatalogId = curPathData.deptFileCatalogId;
                } else {
                    const { children = [], catalogName: parentText } = catalogs || {};
                    const { catalogType, createUser, catalogName: sonText, id, deptFileCatalogId } = children[0] || {};
                    curExpandedKeys = String(catalogs.id);
                    curCatalogId = id;
                    curPathName = `${parentText}-->${sonText}`;
                    curCatalogType = catalogType;
                    curCreateUser = createUser;
                    curDeptFileCatalogId = deptFileCatalogId;
                }

                if (curDeptFileCatalogId) {
                    // 初始加载时异步查询部门文档权限，稍后通过回调更新
                    this.queryDeptFilePremission(curDeptFileCatalogId, curCatalogId);
                }

                this.setState({
                    loading: false,
                    treeData: data,
                    simplifyTreeData,
                    expandedKeys: curExpandedKeys,
                    selectedKeys: [String(curCatalogId)],
                    catalogId: curCatalogId,
                    pathName: curPathName,
                    catalogType: curCatalogType,
                    createUser: curCreateUser,
                    deptFileCatalogId: curDeptFileCatalogId,
                }, () => {
                    this.queryTableData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    //数组扁平化
    flattenList = list => {
        const result = [];
        // 递归遍历函数
        const traverse = (nodes) => {
            nodes.forEach((node) => {
                result.push({ ...node }); // 浅拷贝节点，避免修改原数据
                if (node.children) {
                    traverse(node.children);
                }
            });
        };
        traverse(list);
        return result;
    }

    queryTableData = () => {
        const { catalogId, catalogType, createUser, pagination } = this.state;
        const { current, pageSize } = pagination;
        if (!catalogId) {
            return
        }
        let url = '';
        switch (catalogType) {
            case 'INV_ADDRESS_BOOK':  //项目通讯录
                url = API_URL.invFolder.queryAddressBookList;
                break;
            case 'HANDOVER_RECORD':   //交接记录
                url = API_URL.invFolder.queryHandoverRecord;
                break;
            case 'INV_MAJOR_EVENTS': //重大事件
                url = API_URL.invFolder.queryMajorEventList;
                break;
            default:
                url = API_URL.invFolder.queryInvFileManage;
                break;
        };
        //非预埋数据均调文件查询列表接口
        if (createUser !== -1) {
            url = API_URL.invFolder.queryInvFileManage;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url,
            data: {
                offset: current,
                limit: pageSize,
                catalogId,
                invId: sessionStorage.invId,
            },
            dataType: 'json',
            doneResult: res => {
                const { arry, clearArry } = this.state;
                const { filePage = {} } = res;
                const { datas = [], totalCount } = filePage;
                pagination.total = totalCount;
                datas.forEach((item, index) => item.index = (current - 1) * pageSize + index + 1);

                // 若为 FROM_DEPT_CATALOG 类型目录，根据部门文档权限覆盖文件操作标志
                const { deptFilePremissionMap, catalogId: curCatalogId } = this.state;
                if (catalogType === 'FROM_DEPT_CATALOG') {
                    const deptPerm = (deptFilePremissionMap && deptFilePremissionMap[curCatalogId]) || null;
                    if (deptPerm) {
                        const canDownload = deptPerm.premission == 'OWNER'
                            || deptPerm.premission == 'COMMON'
                            || deptPerm.premission == 'COMMON_CRC'
                            || (deptPerm.otherPremission || '').split(',').includes('DOWNLOAD_FILE');
                        const canDelete = deptPerm.premission == 'OWNER';
                        datas.forEach(item => {
                            if (!canDownload) {
                                item.downloadFlag = false;
                                item.batchDownloadFlag = false;
                                item.previewFlag = false;
                            }
                            if (!canDelete) {
                                item.deleteFlag = false;
                            }
                        });
                    }
                }
                let newArry;
                const newSelectedRowKeys = [];
                if (clearArry) {
                    newArry = arry.filter(item => datas.some(innerItem => innerItem.id == item));
                } else {
                    newArry = arry;
                }
                newArry.forEach(item => {
                    const selectData = datas.find(innerItem => innerItem.id == item);
                    if (selectData) {
                        newSelectedRowKeys.push(selectData.index);
                    }
                });

                this.setState({
                    loading: false,
                    pagination,
                    tableData: datas,
                    arry: newArry,
                    selectedRowKeys: newSelectedRowKeys,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    queryRemarks = () => {
        const { catalogId } = this.state;
        if (!catalogId) {
            return
        }
        const options = {
            method: 'POST',
            url: API_URL.invFolder.queryRemarks,
            data: {
                catalogId,
                invId: sessionStorage.invId,
            },
            dataType: 'json',
            doneResult: res => {
                const { fileRemark } = res;
                this.setState({ titleRemark: fileRemark ? fileRemark.remark : '' });
            },
        };
        $.sendRequest(options);
    }

    queryConfig = () => {
        const options = {
            method: 'POST',
            url: API_URL.execute.queryConfigureList,
            data: {},
            dataType: 'json',
            doneResult: res => {
                this.setState({ majorEventsConfig: res });
            },
        };
        $.sendRequest(options);
    }

    downloadFileBatch = () => {
        const { batchMarkData, catalogId, catalogType } = this.state;
        if (catalogType === 'INV_ADDRESS_BOOK') {
            ExportUtil.export({ invId: sessionStorage.invId, }, null, API_URL.invFolder.exportBatchBook);
        } else if (catalogType === 'HANDOVER_RECORD') {
            if (batchMarkData.length == 0) {
                return message.warning('请选择需要批量下载的文件')
            }
            const sendData = {};
            batchMarkData.map((el, index) => {
                sendData[`handoverDownloadDtoList[${index}].id`] = el.id;
                sendData[`handoverDownloadDtoList[${index}].type`] = el.handoverType;
            });
            ExportUtil.export({ ...sendData, catalogId }, null, API_URL.invFolder.batchDownloadHandoverReport);
        } else {
            if (batchMarkData.length == 0) {
                return message.warning('请选择需要批量下载的文件')
            }
            const sendData = {};
            batchMarkData.map((el, index) => {
                sendData[`fileManageDownload[${index}].id`] = el.id;
                sendData[`fileManageDownload[${index}].source`] = el.source;
            });
            ExportUtil.export({ ...sendData, catalogId }, null, API_URL.folder.downloadFileBatch);
        }
        message.success('正在下载中!');
    }

    preview = (id, fileName) => {
        const formatData = ["xlsx", "pdf", "doc", "png","docx"];
        const suffix = fileName.split('.').pop();
        if (formatData.some(el => el == suffix)) {
            message.success('文档加载中，请稍后', 0);
        } else {
            message.error('该文件格式不支持预览');
            return
        }
        const options = {
            method: 'POST',
            url: API_URL.folder.previewFile,
            data: {
                id,
            },
            dataType: 'json',
            doneResult: res => {
                message.destroy();
                const { str } = res;
                //解析base64编码
                const base64Data = str.replace(/^data:.*?;base64,/, '')  // 去除 Data URL 前缀
                    .replace(/[^A-Za-z0-9+/=]/g, '')    // 过滤非法字符
                    .padEnd(str.length + (4 - (str.length % 4)) % 4, '='); // 补全填充符
                const binaryString = window.atob(base64Data);
                const byteArray = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    byteArray[i] = binaryString.charCodeAt(i);
                }
                //转化为blob对象，获取url
                const blob = new Blob([byteArray], { type: 'application/pdf' });
                const imageUrl = URL.createObjectURL(blob);
                window.open(`${imageUrl}`);
            },
            errorResult: () => {
                message.destroy();
            }
        };
        $.sendRequest(options);
    }

    downloadFile = (id, source, dataType, handoverType) => {
        if (dataType === 'OSS') {
            // OSS下载方式
            // const options = {
            //     method: 'POST',
            //     url: API_URL.folder.downloadOssFile,
            //     data: {
            //         id,
            //     },
            //     dataType: 'json',
            //     doneResult: res => {
            //         const { url } = res;
            //         const link = document.createElement('a');
            //         link.href = url;
            //         link.download = this.getFileName(url); // 关键：设置文件名
            //         link.style.display = 'none';

            //         // 插入DOM并触发点击
            //         document.body.appendChild(link);
            //         link.click();

            //         // 清理DOM
            //         document.body.removeChild(link);
            //         message.success('正在下载中!');
            //     },
            // };
            // $.sendRequest(options);
            ExportUtil.export({ id }, null, API_URL.folder.downloadOssFile);
        } else {
            let url = '';
            switch (source) {
                case 'CRC':
                    url = API_URL.invFolder.exportCrcBook;
                    break;
                case 'CRA':
                    url = API_URL.invFolder.exportCraBook;
                    break;
                case 'PI':
                    url = API_URL.invFolder.exportPiBook;
                    break;
                default:
                    url = API_URL.folder.downloadFile;
                    break;
            }
            if (source === 'MAJOR_EVENT') {
                ExportUtil.export({ majorEventId: id, fileFlag: 'FILE_FLAG' }, null, API_URL.execute.exportMajorEventWord);
            } else if (source === 'HANDOVER') {
                ExportUtil.export({ id, invId: sessionStorage.invId, type: handoverType, fileType: 'report' }, null, API_URL.invFolder.downloadHandoverReport);
                ExportUtil.export({ id, invId: sessionStorage.invId, type: handoverType, fileType: 'plan' }, null, API_URL.invFolder.downloadHandoverReport);
            } else {
                ExportUtil.export({ id, invId: sessionStorage.invId }, null, url);
            }
            message.success('正在下载中!');
        }
    }

    // 提取文件名（兼容URL编码和路径截取）
    getFileName = (url) => {
        // 去除查询参数和哈希部分
        const cleanUrl = url.split('?')[0].split('#')[0];
        // 获取最后一个路径段并解码中文
        const fileNameSegment = cleanUrl.split('/').pop();
        return decodeURIComponent(fileNameSegment);
    };

    deleteFileManage = (id) => {
        const { catalogId } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.invFolder.deleteInvFile,
            data: {
                id,
                catalogId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.queryTableData();
            },
        };
        $.sendRequest(options);
    }

    deleteCatalog = (id) => {
        Modal.confirm({
            iconType: 'question-circle',
            title: <div style={{ marginLeft: 42 }}>确定要删除该文档分类吗？</div>,
            content: '删除后无法恢复，相关已上传文件也会一起删除',
            onOk: () => {
                const options = {
                    method: 'POST',
                    url: API_URL.invFolder.deleteInvCatalog,
                    data: {
                        id,
                    },
                    dataType: 'json',
                    doneResult: res => {
                        message.success(res.success);
                        this.loadData();
                    },
                };
                $.sendRequest(options);
            },
        });
    }

    onExpand = (expandedKeys) => {
        this.setState({
            expandedKeys,
            autoExpandParent: false,
        });
    }

    onTreeNodeSelect = (selectedKeys) => {
        this.setState({ selectedKeys });
    }

    /**
     * 查询用户在部门文档目录中的权限（用于迁移到项目内的目录）
     * @param {number} deptFileCatalogId 部门文档目录ID
     * @param {number} [targetCatalogId] 项目目录ID（默认使用当前 state.catalogId）
     */
    queryDeptFilePremission = (deptFileCatalogId, targetCatalogId) => {
        const { deptFilePremissionMap, catalogId, catalogType } = this.state;
        const key = targetCatalogId || catalogId;
        // 如果已缓存，直接使用
        if (deptFilePremissionMap[key]) {
            return;
        }
        const options = {
            method: 'POST',
            url: API_URL.deptFile.queryFileCatalogPremission,
            data: {
                catalogId: deptFileCatalogId,
            },
            dataType: 'json',
            doneResult: res => {
                const { premission, otherPremission } = res;
                const currentCatalogId = this.state.catalogId;
                this.setState({
                    deptFilePremissionMap: {
                        ...this.state.deptFilePremissionMap,
                        [key]: { premission, otherPremission },
                    },
                }, () => {
                    // 权限查询成功后，若当前显示的目录是同一个，刷新表格以应用权限标志
                    if (currentCatalogId === key && catalogType === 'FROM_DEPT_CATALOG') {
                        this.queryTableData();
                    }
                });
            },
            errorResult: () => {
                // 查询失败不影响正常功能
                console.warn('查询部门文档权限失败');
            },
        };
        $.sendRequest(options);
    }

    onSelect = (id, sonText, catalogType, createUser, deptFileCatalogId) => {
        if (catalogType == 'CRC_PROCOTOL_LETTER') {
            return
        }
        const { treeData, pagination, deptFilePremissionMap } = this.state;
        const path = this.findNodePath(treeData, id);
        const pathName = (path || []).map((node) => node.catalogName).join('-->');

        // 若目录是从部门文档迁移过来的（有 deptFileCatalogId），查询用户在部门文档中的权限
        if (deptFileCatalogId) {
            this.queryDeptFilePremission(deptFileCatalogId, id);
        } else {
            this.setState({ deptFilePremissionMap: { ...deptFilePremissionMap, [id]: null } });
        }

        this.setState({
            pathName,
            sonText,
            pagination: {
                ...pagination,
                current: 1,
            },
            catalogId: id,
            catalogType,
            createUser, //用于判断目录是否预埋
            clearArry: true,
            deptFileCatalogId, // 保存当前目录的 deptFileCatalogId
        }, () => {
            this.queryTableData();
            if (catalogType == 'INV_TRAIN_MATERIAL' || catalogType == 'CRC_PROCOTOL' || catalogType == 'CRC_LETTER') this.queryRemarks();
            if (catalogType == 'INV_MAJOR_EVENTS') this.queryConfig();
        })
    }

    // 递归查找节点路径
    findNodePath = (nodes, targetKey, path = []) => {
        for (const node of nodes) {
            const currentPath = [...path, node];
            if (node.id == targetKey) {
                return currentPath;
            }
            if (node.children) {
                const found = this.findNodePath(node.children, targetKey, currentPath);
                if (found) return found;
            }
        }
        return null;
    };

    onChange = (e) => {
        const { simplifyTreeData } = this.state;
        const value = e.target.value;
        const expandedKeys = [];
        simplifyTreeData.map(el => {
            if (el.catalogName.indexOf(value) > -1) {
                expandedKeys.push(String(el.id));
            }
        });
        this.setState({
            expandedKeys,
            searchValue: value,
            autoExpandParent: true,
        });
    }

    setTipTittle = (text) => {
        if (!text) {
            return ''
        }
        const arr = (text || "").split("\n");
        const tipTitle = (
            <div>
                <span style={{ color: 'yellow' }}>注意：自查要点</span><br />
                {arr.map(el => (
                    <span>
                        {el}
                        <br />
                    </span>
                ))}
            </div>
        );
        return tipTitle
    }

    setTipTittle = (text) => {
        if (!text) {
            return ''
        }
        const arr = (text || "").split("\n");
        const tipTitle = (
            <div>
                {arr.map(el => (
                    <span>
                        {el}
                        <br />
                    </span>
                ))}
            </div>
        );
        return tipTitle
    }

    getColumns = () => {
        const { catalogType, titleRemark } = this.state;
        let columns = [];
        const haveRemark = (catalogType == 'INV_TRAIN_MATERIAL' || catalogType == 'CRC_PROCOTOL' || catalogType == 'CRC_LETTER') && titleRemark;
        switch (catalogType) {
            case 'INV_ADDRESS_BOOK':
                columns = [{
                    title: '名称',
                    dataIndex: 'fileName',
                    key: 'fileName',
                    width: 120,
                }, {
                    title: '更新时间',
                    dataIndex: 'uploadTime',
                    key: 'uploadTime',
                    width: 120,
                    render: text => text ? moment(text).format('YYYY-MM-DD') : ''
                }, {
                    title: '上传人员',
                    dataIndex: 'uploadUserName',
                    key: 'uploadUserName',
                    width: 80,
                    render: text => text ? text : '-'
                }];
                break;
            case 'SCHEME_GUIDE':
                columns = [{
                    title: '名称',
                    dataIndex: 'fileName',
                    key: 'fileName',
                    width: 120,
                }, {
                    title: '上传时间',
                    dataIndex: 'uploadTime',
                    key: 'uploadTime',
                    width: 120,
                    render: text => text ? moment(text).format('YYYY-MM-DD') : ''
                }, {
                    title: '上传人员',
                    dataIndex: 'uploadUserName',
                    key: 'uploadUserName',
                    width: 120,
                    render: text => text ? text : '-'
                }, {
                    title: '是否允许CRC下载',
                    dataIndex: 'crcDownloadFlag',
                    key: 'crcDownloadFlag',
                    width: 120,
                    render: text => text ? (text == 'YES' ? '是' : '否') : '-'
                }, {
                    title: '版本号',
                    dataIndex: 'version',
                    key: 'version',
                    width: 120,
                }];
                break;
            case 'FEASIBILITY_STUDY_REPORT':
            case 'INV_TRAIN_MATERIAL':
                columns = [{
                    title: haveRemark ? <span>
                        名称
                        <Tooltip placement="right" overlayClassName="head_tip" title={this.setTipTittle(titleRemark)}>
                            <a className='fileIcon_style'><Icon style={{ fontSize: 14 }} type="info-circle" /></a>
                        </Tooltip>
                    </span> : '名称',
                    dataIndex: 'fileName',
                    key: 'fileName',
                    width: 120,
                }, {
                    title: '上传时间',
                    dataIndex: 'uploadTime',
                    key: 'uploadTime',
                    width: 120,
                    render: text => text ? moment(text).format('YYYY-MM-DD') : ''
                }, {
                    title: '上传人员',
                    dataIndex: 'uploadUserName',
                    key: 'uploadUserName',
                    width: 120,
                    render: text => text ? text : '-'
                }, {
                    title: '是否允许CRC下载',
                    dataIndex: 'crcDownloadFlag',
                    key: 'crcDownloadFlag',
                    width: 120,
                    render: text => text ? (text == 'YES' ? '是' : '否') : '-'
                }];
                break;
            case 'INV_MANAGEMENT_PLAN':
            case 'INV_MEETING_MINUTES':
            case 'INV_PROGRESS_REPORT':
            case 'INV_EXECUTION_REPORT':
            case 'FINANCIAL_DOCUMENTS':
            case 'OTHER':
                columns = [{
                    title: '名称',
                    dataIndex: 'fileName',
                    key: 'fileName',
                    width: 120,
                }, {
                    title: '上传时间',
                    dataIndex: 'uploadTime',
                    key: 'uploadTime',
                    width: 120,
                    render: text => text ? moment(text).format('YYYY-MM-DD') : ''
                }, {
                    title: '上传人员',
                    dataIndex: 'uploadUserName',
                    key: 'uploadUserName',
                    width: 120,
                    render: text => text ? text : '-'
                }, {
                    title: '版本号',
                    dataIndex: 'version',
                    key: 'version',
                    width: 120,
                }];
                break;

            case 'COLLABORATIVE_VISIT':
            case 'INV_MAJOR_EVENTS':
                columns = [{
                    title: '名称',
                    dataIndex: 'fileName',
                    key: 'fileName',
                    width: 120,
                    render: (text, record) => {
                        const { source, id, downloadFlag } = record;
                        const data = { majorEventNumber: text, majorEventId: id };
                        return (source === 'MAJOR_EVENT' && downloadFlag) ? <a onClick={() => this.handleMajorEventsChange(data, 'view')}>{text}</a> : text
                    }
                }, {
                    title: '上传时间',
                    dataIndex: 'uploadTime',
                    key: 'uploadTime',
                    width: 100,
                    render: text => text ? moment(text).format('YYYY-MM-DD') : ''
                }, {
                    title: '上传人员',
                    dataIndex: 'uploadUserName',
                    key: 'uploadUserName',
                    width: 80,
                    render: text => text ? text : '-'
                }, {
                    title: '涉及层面',
                    dataIndex: 'involveLevelShow',
                    key: 'involveLevelShow',
                    width: 80,
                }, {
                    title: '涉及中心',
                    dataIndex: 'involveSiteName',
                    key: 'involveSiteName',
                    width: 120,
                }, {
                    title: '事件处理结束与否',
                    dataIndex: 'isHandle',
                    key: 'isHandle',
                    width: 80,
                    render: text => text ? (text == '1' ? '是' : '否') : ''
                }];
                break;
            case 'CRC_PROCOTOL':
            case 'CRC_LETTER':
            case 'INV_MEMBER_VITAE':
                columns = [{
                    title: haveRemark ? <span>
                        名称
                        <Tooltip placement="right" overlayClassName="head_tip" title={this.setTipTittle(titleRemark)}>
                            <a className='fileIcon_style'><Icon style={{ fontSize: 14 }} type="info-circle" /></a>
                        </Tooltip>
                    </span> : '名称',
                    dataIndex: 'fileName',
                    key: 'fileName',
                    width: 120,
                }, {
                    title: '上传时间',
                    dataIndex: 'uploadTime',
                    key: 'uploadTime',
                    width: 120,
                    render: text => text ? moment(text).format('YYYY-MM-DD') : ''
                }, {
                    title: '上传人员',
                    dataIndex: 'uploadUserName',
                    key: 'uploadUserName',
                    width: 120,
                    render: text => text ? text : '-'
                }, {
                    title: '涉及中心',
                    dataIndex: 'involveSiteName',
                    key: 'involveSiteName',
                    width: 120,
                }, {
                    title: '是否允许CRC下载',
                    dataIndex: 'crcDownloadFlag',
                    key: 'crcDownloadFlag',
                    width: 120,
                    render: text => text ? (text == 'YES' ? '是' : '否') : '-'
                }];
                break;
            case 'HANDOVER_RECORD':
                columns = [{
                    title: '交接编号',
                    dataIndex: 'fileName',
                    key: 'fileName',
                    width: 120,
                    render: (text, record) => {
                        const { id, handoverType, downloadFlag } = record;
                        return downloadFlag ? <a onClick={() => this.viewReport(id, handoverType)}>{text}</a> : text
                    }
                }, {
                    title: '交接类型',
                    dataIndex: 'handoverType',
                    key: 'handoverType',
                    width: 120,
                }, {
                    title: '涉及中心',
                    dataIndex: 'involveSiteName',
                    key: 'involveSiteName',
                    width: 120,
                }, {
                    title: '交接状态',
                    dataIndex: 'handoverStatusShow',
                    key: 'handoverStatusShow',
                    width: 120,
                }];
                break;
            case 'FROM_DEPT_CATALOG':
                columns = [{
                    title: '名称',
                    dataIndex: 'fileName',
                    key: 'fileName',
                    width: 120,
                }, {
                    title: '上传时间',
                    dataIndex: 'uploadTime',
                    key: 'uploadTime',
                    width: 120,
                    render: text => text ? moment(text).format('YYYY-MM-DD') : ''
                }, {
                    title: '上传人员',
                    dataIndex: 'uploadUserName',
                    key: 'uploadUserName',
                    width: 120,
                    render: text => text ? text : '-'
                }];
                break;
        }
        columns.push({
            title: "操作",
            key: "operate",
            dataIndex: "operate",
            width: 110,
            render: (text, record) => {
                const { id, source, previewFlag, downloadFlag, deleteFlag, dataType, handoverType, fileName } = record;
                const { curRole } = sessionStorage;
                //按可见按钮动态组装，任意相邻按钮之间显示分隔线
                const buttons = [];
                if (previewFlag) {
                    buttons.push(<a key="preview" onClick={() => this.preview(id, fileName)}>预览</a>);
                }
                if (downloadFlag) {
                    buttons.push(<a key="download" onClick={() => this.downloadFile(id, source, dataType, handoverType)}>下载</a>);
                }
                if (deleteFlag) {
                    buttons.push(
                        <Popconfirm key="delete" title='确定要删除吗？删除后无法恢复，相关已上传文件也会一起删除' onConfirm={() => this.deleteFileManage(id)} okText="确定" cancelText="取消">
                            <a>删除</a>
                        </Popconfirm>
                    );
                }
                const nodes = [];
                buttons.forEach((button, index) => {
                    if (index > 0) {
                        nodes.push(<span key={`divider${index}`} className="ant-divider" />);
                    }
                    nodes.push(button);
                });
                return (
                    <span>{nodes}</span>
                );
            }
        });
        return columns
    }

    viewReport = (id, handoverType) => {
        if (handoverType === 'CRC交接') {
            this.viewReportRef.show(id);
        } else {
            this.queryStaffHandover(id);
        }
    }

    queryStaffHandover = (id) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.execute.queryStaffHandoverList,
            data: {
                staffHandoverId: id
            },
            dataType: 'json',
            doneResult: res => {
                const { datas } = res;
                this.pmReportRef.show(datas[0]);
                this.setState({ loading: false });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }


    onSelectChange = (record, selected) => {
        const { selectedRowKeys, arry, tableData, batchMarkData } = this.state;
        if (selected) {
            const isExist = selectedRowKeys.some(item => item == record.index);
            !isExist && selectedRowKeys.push(record.index);
            const isIdExist = arry.some(item => item == record.id);
            if (!isIdExist) {
                arry.push(record.id);
                tableData.map(el => {
                    if (el.id == record.id) {
                        batchMarkData.push({ ...el });
                    }
                });
            }
        } else {
            let idx;
            selectedRowKeys.forEach((item, index) => {
                if (record.index == item) {
                    idx = index;
                }
            });
            (idx || (!idx && idx === 0)) && selectedRowKeys.splice(idx, 1);

            // 删除已存在的id
            let idIdx;
            arry.forEach((item, index) => {
                if (record.id == item) {
                    idIdx = index;
                }
            });
            if (idIdx || (!idIdx && idIdx === 0)) {
                arry.splice(idIdx, 1);
                batchMarkData.splice(idIdx, 1);
            }
        }
        this.setState({
            arry,
            selectedRowKeys,
            batchMarkData,
        });
    }

    onSelectAllChange = (selected, selectedRows, changeRows) => {
        const { arry, selectedRowKeys, tableData, batchMarkData } = this.state;
        if (selected) {
            changeRows.forEach(item => {
                let idx;
                selectedRowKeys.forEach((selectItem, index) => {
                    if (selectItem == item.index) {
                        idx = index;
                    }
                });
                !(idx || (!idx && idx === 0)) && selectedRowKeys.push(item.index);

                let idIdx;
                arry.forEach((arryItem, index) => {
                    if (arryItem == item.id) {
                        idIdx = index;
                    }
                });
                if (!(idIdx || (!idIdx && idIdx === 0))) {
                    arry.push(item.id);
                    tableData.map(el => {
                        if (el.id == item.id) {
                            batchMarkData.push({ ...el });
                        }
                    });
                }
            });
        } else {
            changeRows.forEach(item => {
                let idx;
                selectedRowKeys.forEach((selectItem, index) => {
                    if (selectItem == item.index) {
                        idx = index;
                    }
                });
                (idx || (!idx && idx === 0)) && selectedRowKeys.splice(idx, 1);

                let idIdx;
                arry.forEach((arryItem, index) => {
                    if (arryItem == item.id) {
                        idIdx = index;
                    }
                });
                if (idIdx || (!idIdx && idIdx === 0)) {
                    arry.splice(idIdx, 1);
                    batchMarkData.splice(idIdx, 1);
                }
            });
        }
        this.setState({
            arry,
            selectedRowKeys,
            batchMarkData,
        });
    }

    handleTableChange = (pagination) => {
        this.setState({
            pagination,
            clearArry: false,
        }, () => {
            this.queryTableData();
        });
    }

    skip = (catalogType) => {
        let path = '';
        switch (catalogType) {
            case 'HANDOVER_RECORD':
                path = './#/execute/transfer';
                break;
            case 'INV_MAJOR_EVENTS':
                path = './#/execute/importantEvent';
                break;
        }
        if (path) location.href = path;
    }

    leave = () => {
        window.history.go(-1);
    }

    //判断字段是否等于某些值
    booleanEquals = (key, value = []) => {
        return value.some((el) => key === el);
    };

    handleMajorEventsChange = (data, status) => {
        this.setState({
            majorEventsData: data,
            majorEventsStatus: status,
        });
    }

    render() {
        const {
            treeData,
            tableData,
            loading,
            pagination,
            searchValue = '',
            expandedKeys,
            selectedKeys,
            autoExpandParent,
            catalogId,
            catalogType,
            selectedRowKeys,
            pathName,
            majorEventsStatus,
            majorEventsConfig,
            majorEventsData,
            titleRemark,
            deptFilePremissionMap,
            deptFileCatalogId,
        } = this.state;
        console.log(selectedKeys);
        const loop = data => (data || []).map(item => {
            const { id, catalogName, createUser, catalogDesc, catalogIndex, catalogType, deptFileCatalogId } = item;
            const isSearch = searchValue ? catalogName.includes(searchValue) : false;
            const fontContent = <Tooltip placement="right" title={catalogName}>
                <span className='ellipsis'>{catalogName}</span>
            </Tooltip>;

            const tipTitle = this.setTipTittle(catalogDesc);
            const { curRole } = sessionStorage;
            const prohibitAdd = this.booleanEquals(catalogType, ['INV_ADDRESS_BOOK', 'INV_MANAGEMENT_PLAN', 'HANDOVER_RECORD', 'INV_MAJOR_EVENTS', 'CRC_PROCOTOL_LETTER']);  //不能添加子目录的类型
            const canEditCatalog = curRole == 'PM' || curRole == 'PA'; //可以对目录进行操作的角色

            const title =
                <div className='catalog_content' style={{ marginTop: catalogIndex == 1 ? -6 : 0, backgroundColor: isSearch ? '#cfe8fc' : undefined }}>
                    {
                        catalogIndex == 1 ? <span style={{ display: 'flex', alignItems: 'center' }}>
                            <i className="icon iconfont" style={{ marginRight: 3, fontSize: '22px', color: '#5959df' }}>&#xe6cf;</i>
                            {fontContent}
                        </span> : <span
                            style={{ display: 'flex' }}
                            onClick={() => this.onSelect(id, catalogName, catalogType, createUser, deptFileCatalogId)}
                        >
                            <Icon type="folder-open" style={{ marginRight: 3, color: '#5959df' }} />
                            {fontContent}
                        </span>
                    }
                    {
                        (createUser != -1 && canEditCatalog) && <span onClick={() => this.UpdateCatalogRef.show('edit', id, catalogName, catalogDesc)} className='fileIcon_style'><Icon style={{ fontSize: 14 }} type="edit" /></span>
                    }
                    {
                        (createUser != -1 && canEditCatalog) && <span onClick={() => this.deleteCatalog(id)} className='fileIcon_style'><Icon style={{ fontSize: 14 }} type="minus-circle-o" /></span>
                    }
                    {
                        (catalogIndex != 5 && catalogIndex != 1  && canEditCatalog && !prohibitAdd) && <span onClick={() => this.UpdateCatalogRef.show('add', id)} className='fileIcon_style'><Icon style={{ fontSize: 14 }} type="plus-circle-o" /></span>
                    }
                    {
                        !!tipTitle && <Tooltip placement="right" overlayClassName="head_tip" title={tipTitle}>
                            <a className='fileIcon_style'><Icon style={{ fontSize: 14 }} type="info-circle" /></a>
                        </Tooltip>
                    }

                </div>;
            return (
                <TreeNode key={String(item.id)} title={title}>
                    {loop(item.children)}
                </TreeNode>
            );
        });

        const rowSelection = {
            selectedRowKeys,
            onSelect: this.onSelectChange,
            onSelectAll: this.onSelectAllChange,
            getCheckboxProps: record => ({
                disabled: !record.batchDownloadFlag,
            }),
        };

        const { curRole, siteId } = sessionStorage;
        const canSkip = this.booleanEquals(catalogType, ['HANDOVER_RECORD', 'INV_MAJOR_EVENTS']);

        // 判断是否有部门文档上传权限（用于 FROM_DEPT_CATALOG 类型目录）
        const curDeptPermission = (deptFileCatalogId && deptFilePremissionMap && deptFilePremissionMap[catalogId])
            ? deptFilePremissionMap[catalogId]
            : null;
        const hasDeptUploadPermission = curDeptPermission && (
            curDeptPermission.premission == 'OWNER'
            || (curDeptPermission.otherPremission || '').split(',').includes('UPLOAD_FILE')
        );
        const hasDeptDownloadPermission = curDeptPermission && (
            curDeptPermission.premission == 'OWNER'
            || curDeptPermission.premission == 'COMMON'
            || curDeptPermission.premission == 'COMMON_CRC'
            || (curDeptPermission.otherPremission || '').split(',').includes('DOWNLOAD_FILE')
        );
        const hasDeptOwnerPermission = curDeptPermission && curDeptPermission.premission == 'OWNER';

        // FROM_DEPT_CATALOG 类型目录：使用部门文档权限判断是否能上传
        const isFromDeptCatalog = catalogType === 'FROM_DEPT_CATALOG';

        const canUploadFile =
            // 部门文档迁移目录且有部门目录ID → 使用部门文档上传权限
            (isFromDeptCatalog && deptFileCatalogId) ? !!hasDeptUploadPermission
            // 部门文档迁移目录但无部门目录ID（项目内新增子目录）→ 降级为项目会议纪要权限
            : (isFromDeptCatalog && !deptFileCatalogId) ? (siteId == 0 && (curRole == 'PM' || curRole == 'PA'))
            // 标准目录
            : (
                //中心汇总下，上传文件权限
                siteId == 0
                &&
                (
                    (
                        this.booleanEquals(catalogType, [
                            'SCHEME_GUIDE',
                            'FEASIBILITY_STUDY_REPORT',
                            'INV_MANAGEMENT_PLAN',
                            'INV_TRAIN_MATERIAL',
                            'INV_MEETING_MINUTES',
                            'INV_PROGRESS_REPORT',
                            'COLLABORATIVE_VISIT',
                            'INV_EXECUTION_REPORT',
                            'INV_MAJOR_EVENTS',
                            'FINANCIAL_DOCUMENTS', 'OTHER'
                        ])
                        && (curRole == 'PM' || curRole == 'PA')
                    )
                    ||
                    (
                        this.booleanEquals(catalogType, [
                            'CRC_LETTER',
                            'CRC_PROCOTOL',
                            'INV_MEMBER_VITAE',
                        ])
                        && (curRole == 'PM' || curRole == 'PA' || curRole == 'CSA')
                    )
                )
            )
            ||
            (
                //具体中心下，上传文件权限
                siteId != 0
                &&
                this.booleanEquals(catalogType, [
                        'INV_TRAIN_MATERIAL',
                        'COLLABORATIVE_VISIT',
                        'CRC_PROCOTOL',
                        'CRC_LETTER',
                        'INV_MEMBER_VITAE',
                        'INV_MAJOR_EVENTS',
                    ])
                && curRole == 'CRC'
            );
        const canSetRemark = isFromDeptCatalog
            ? !!hasDeptOwnerPermission
            : this.booleanEquals(catalogType, ['INV_TRAIN_MATERIAL', 'CRC_PROCOTOL', 'CRC_LETTER']) && (curRole == 'PM' || curRole == 'PA');
        return (
            <div className="content">
                <SideNav selectKey='projectFile' />
                <div className="main" style={{ display: majorEventsStatus ? 'none' : undefined }}>
                    <Spin spinning={loading}>
                    <div className='file_content'>
                        <div className='left'>
                            <span>
                                <Select
                                    style={{ marginBottom: 8, width: 70 }}
                                    defaultValue={'文件夹'}
                                >
                                    <Option value={'文件夹'}>{'文件夹'}</Option>
                                </Select>
                                <Search style={{ marginBottom: 8, width: 180 }} placeholder="请输入" onChange={this.onChange} />
                            </span>
                            <Tree
                                showLine
                                onExpand={this.onExpand}
                                onSelect={this.onTreeNodeSelect}
                                expandedKeys={expandedKeys}
                                selectedKeys={selectedKeys}
                                autoExpandParent={autoExpandParent}
                            >
                                {loop(treeData)}
                            </Tree>
                        </div>
                        <div className='right'>
                            <div className='table_top'>
                                <div className='top_left'>
                                    <Icon style={{ marginRight: 5 }} type="environment-o" />
                                    {
                                        canSkip ? <a onClick={() => this.skip(catalogType)}>{pathName}</a> : pathName
                                    }
                                </div>
                                <div className='top_right'>
                                    {
                                        canSetRemark && <Button
                                            style={{ marginRight: 20 }}
                                            type="primary"
                                            onClick={() => this.SetRemarklRef.show(catalogId, titleRemark, pathName)}
                                        >设置备注</Button>
                                    }
                                    
                                        <Button
                                            key="downloadFileBatch"
                                            type="primary"
                                            onClick={this.downloadFileBatch}
                                        >批量下载</Button>
                                    
                                    {
                                        canUploadFile && <Button
                                            style={{ marginLeft: 20 }}
                                            type="primary"
                                            onClick={() => this.UploadFileModalRef.show(catalogId, catalogType, pathName)}
                                        >上传文件</Button>
                                    }
                                </div>

                            </div>
                            <Table
                                bordered
                                rowSelection={rowSelection}
                                rowKey={record => record.index}
                                pagination={pagination}
                                dataSource={tableData}
                                scroll={{ x: 500 }}
                                // loading={loading}
                                columns={this.getColumns()}
                                onChange={this.handleTableChange}
                            />
                        </div>
                    </div>
                    <UpdateCatalog ref={el => this.UpdateCatalogRef = el} loadData={this.loadData} />
                    <UploadFileModal ref={el => this.UploadFileModalRef = el} queryTableData={this.queryTableData} />
                    <SetRemark ref={el => this.SetRemarklRef = el} queryRemarks={this.queryRemarks} />
                    <PMreport
                        ref={el => { this.pmReportRef = el; }}
                    />
                    <ViewReportModal
                        ref={el => { this.viewReportRef = el; }}
                    />
                    </Spin>
                </div>
                {majorEventsStatus && <Update data={majorEventsData} config={majorEventsConfig} status={majorEventsStatus} onChange={this.handleMajorEventsChange} />}
            </div>
        )
    }
}

export default ProjectFile





// WEBPACK FOOTER //
// ./src/components/fileManagement/projectFile/index.js